import { request } from "./api";

// export function postHuiyi(params) {
//   const { zid,uid,guest, tel, xiangxishuoming } = params;
//   const formData = new FormData();
//   formData.append('zid', zid);
//   formData.append('uid', uid);
//   formData.append('guest', guest);
//   formData.append('tel', tel);
//   formData.append('xiangxishuoming', xiangxishuoming);
//   formData.append('a', a);

//   return fetch('shuihotel/index.php?m=agent', {
//     method: 'POST',
//     body: formData,
//   })
//   .then(response => response.json())
//   .then(data => {
//     // 处理响应数据
//     return data;
//   })
//   .catch(error => {
//     // 处理错误
//     console.error('Error:', error);
//   });
// }
 
export function postHuiyi({ ...restParams } = {}) {
  const queryParams = new URLSearchParams({
    ...restParams
  }).toString();

  return fetch(`https://csweb.xiaodianjia.cn/h5pay/order_detail.php?${queryParams}`)
    .then(response => response.json())
    .then(data => {
      // 处理响应数据
      return data;
    })
    .catch(error => {
      // 处理错误
      console.error('Error:', error);
    });
}

 export function postHuiyiabc({ ...restParams } = {}) {
  return fetch(`https://nice.xiaodianjia.cn/book/add_meeting_web`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: new URLSearchParams({
      ...restParams
    }).toString()
  })
    .then(response => response.json())
    .then(data => {
      return data;
    })
    .catch(error => {
      console.error("Error:", error);
    });
}


 
// export function postHuiyiabc({ ...restParams } = {}) {
//   const queryParams = new URLSearchParams({
//     ...restParams
//   }).toString();

//   return fetch(`https://api.tetuijiudian.com/shuia/index.php?g=content&m=agent&${queryParams}`)
//     .then(response => response.json())
//     .then(data => {
//       // 处理响应数据
//       return data;
//     })
//     .catch(error => {
//       // 处理错误
//       console.error('Error:', error);
//     });
// }

 
 
